import React from "react";
import { nf } from "../lib/format";

// Money input masked in the user's market format (BR 1.250,00 · US 1,250.00 · EU 1.250,00).
// `value` in/out is a plain numeric string (e.g. "1250" or "1250.5"); typing works like a cash register (last 2 digits = cents).
export function MoneyInput({ value, onChange, className, testid, placeholder = "0" }) {
  const display = value === "" || value == null ? "" : nf(value);
  const handle = (e) => {
    const digits = e.target.value.replace(/\D/g, "");
    onChange(digits ? String(Number(digits) / 100) : "");
  };
  return (
    <input type="text" inputMode="decimal" data-testid={testid} value={display} onChange={handle}
      placeholder={placeholder} className={className} />
  );
}
